import React, { useEffect, useState } from "react";
import { Formik, useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCategories } from "../../store/slices/categorySlice";
import LayoutPresta from "./layoutPresta";
import {  getMyEtablissement, resetCreateStatus, updatedEtablissement } from "../../store/slices/etablissementSlice";
import { ActivityTypeForm } from "../../components/etablissement/type";
import * as Yup from "yup";
import { Helmet, HelmetProvider } from "react-helmet-async";

function TypeActivity() {
  const location = useLocation();
  const data = location?.state;
  const dispatch = useDispatch();
  const navigate=useNavigate()
  const { categories } = useSelector((state) => state.categories);
  const { createStatus ,selectedEtablissement} = useSelector(state => state.etablissements);
  // console.log(selectedEtablissement)
  useEffect(()=>{
    dispatch(getMyEtablissement())
   
  },[])
  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  const validationSchema = Yup.object().shape({
    domaine: Yup.number().required("Le domaine d'activité est requis"),
    type: Yup.number().required("Le type d'activité est requis"),
    activity: Yup.number().required("L'activité est requise"),
    lieux: Yup.array()
      .min(1, "Sélectionnez au moins un lieu d'intervention")
      .required("Les lieux d'intervention sont requis"),
    immediat: Yup.boolean().required("Ce champ est requis"),
  });

  // Determine initial values
  const getInitialValues = () => {
    const etablissement = selectedEtablissement ;
    
    if (!etablissement) {
      return {
        immediat: true,
        domaine: "",
        type: "",
        activity: "",
        lieux: [],
      };
    }
    return {
      immediat: etablissement.immediat === 0 ? false : true,
      domaine: etablissement.domaine_activite ? parseInt(etablissement.domaine_activite) : "",
      type: etablissement.type ? parseInt(etablissement.type) : "",
      activity: etablissement.activite ? parseInt(etablissement.activite) : "",
      lieux: etablissement.lieu_intervention || [],
    };
  };

  const initialValues = getInitialValues();
  // console.log({initialValues})
  
  const handleSubmit = (values) => {
   
    // console.log({ ...values, ...data });
    const toSavedData={
      ...data,
      activite:values?.activity,
      domaine_activite:values?.domaine,
      type:values?.type,
      lieu_intervention:values?.lieux,
      immediat:values.immediat
    }
  // dispatch(createEtablissement(toSavedData));
  if(selectedEtablissement){
        dispatch(updatedEtablissement({
          etablissementData: toSavedData,
          route:`etablissements/${selectedEtablissement?.id}`
        }))
      .then((res)=>{
        // console.log(res)
        const stepsStatus = JSON.parse(localStorage.getItem("stepsStatus")) || {};
        stepsStatus[2] = "completed";
        localStorage.setItem("stepsStatus", JSON.stringify(stepsStatus));
        navigate("/ouverture")
      })
      .catch((err)=>{
        // console.log(err)
      })
      }
 
    
  };
  useEffect(() => {
    if (createStatus === 'succeeded') {
      // Navigate to desired path after successful creation
  
      navigate('/ouverture'); 
    }
  }, [createStatus, navigate]);
// Reset create status when component unmounts
useEffect(() => {
  return () => {
    dispatch(resetCreateStatus());
  };
}, [dispatch]);
  return (
    <>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize={true} 
       validationSchema={validationSchema} // Add this line
       >
        <FormContent categories={categories} />
      </Formik>
    </>
  );
}

// Child component for form content
function FormContent({ categories }) {
  const { values, setFieldValue, submitForm ,isSubmitting,errors, touched } = useFormikContext();

  // State to store filtered types and activities
  const [filteredTypes, setFilteredTypes] = useState([]);
  const [filteredActivities, setFilteredActivities] = useState([]);

  // When domaine changes, update types
  useEffect(() => {
    if (values.domaine) {
      const selectedDomaine = categories.find((cat) => cat.id === values.domaine);
  
      if (selectedDomaine && selectedDomaine.children) {
        setFilteredTypes(selectedDomaine.children);
  
        // Only reset if there is no value
        if (!values.type) {
          setFieldValue("type", "");
        }
  
        if (!values.activity) {
          setFieldValue("activity", "");
        }
      }
    } else {
      setFilteredTypes([]);
      setFilteredActivities([]);
    }
  }, [values.domaine, categories, setFieldValue]);
  

  // When type changes, update activities
  useEffect(() => {
    if (values.type) {
      const selectedType = filteredTypes.find((type) => type.id === values.type);
      if (selectedType && selectedType.children) {
        setFilteredActivities(selectedType.children);
  
        if (!values.activity) {
          setFieldValue("activity", "");
        }
      }
    } else {
      setFilteredActivities([]);
    }
  }, [values.type, filteredTypes, setFieldValue]);
  

  return (
    <LayoutPresta
      currentStep={2}
      nextStep={"/ouverture"}
      handleSubmit={submitForm} // Pass submitForm to LayoutPresta
      disabled={isSubmitting} // Pass isSubmitting to LayoutPresta
      btn={false}
    >
       <HelmetProvider>
                        <Helmet>
                          <title>Inscription Prestataire </title>
                          <meta
                            name="description"
                            content="Inscription Prestataire étape type activité , domaine , lieux interventions .... "
                          />
                        </Helmet>
                      </HelmetProvider>
      <div className="col-md-6 mx-auto mt-48">
        <ActivityTypeForm categories={categories} errors={errors} touched={touched} />
        <div className="ht-100"></div>
        <div className="ht-80"></div>
      </div>
        
 
    </LayoutPresta>
  );
}

export default TypeActivity;